<template>
  <q-page>
    <div class="row full-width">
      <div style="width: 75%">
        <div class="q-pa-none">
          <div class="row full-width">
            <div style="width: 100%">
              <topbar backgroundColor="#162c47">
                <template v-slot:content>
                  <div class="row q-mb-md justify-between">
                    <div>
                      <span class="header-title text-white">
                        Search the <strong>Solutions Database</strong>
                      </span>
                    </div>
                    <q-btn
                      :color="showSavedSolutions ? 'white' : 'primary'"
                      :text-color="showSavedSolutions ? 'black' : 'white'"
                      no-caps
                      @click="showSavedSolutions = !showSavedSolutions"
                    >
                      <span class="showSavedSolutionsText">
                        {{
                          showSavedSolutions
                            ? "Show Full Database"
                            : "Show Saved Solutions"
                        }}
                      </span>
                    </q-btn>
                  </div>
                  <div class="row">
                    <div
                      class="filterButton cursor-pointer q-px-sm q-py-xs q-mr-sm"
                    >
                      <div class="row items-center">
                        <q-icon name="mdi-filter-outline" size="xs"> </q-icon>
                        <span class="filtersText"> Filters </span>
                      </div>
                      <q-menu>
                        <div
                          style="
                            min-width: 600px;
                            max-width: 600px;
                            background-color: #f6f6f6;
                          "
                          class="q-pa-md"
                        >
                          <div class="row">
                            <div class="filtersTitle">Outcomes</div>
                          </div>
                          <div class="row q-col-gutter-sm q-py-md">
                            <div
                              v-for="(outcome, index) in outcomesList"
                              :key="`outcomeFilter_${index}`"
                              class="col-auto"
                            >
                              <q-card
                                flat
                                class="q-pa-sm outcomeCardSelector"
                                :class="{
                                  active:
                                    selectedOutcomeFilter &&
                                    selectedOutcomeFilter.id == outcome.id,
                                }"
                                @click="selectedOutcomeFilter = outcome"
                              >
                                {{ outcome.label }}
                                <q-btn
                                  v-if="
                                    selectedOutcomeFilter &&
                                    selectedOutcomeFilter.id == outcome.id
                                  "
                                  icon="mdi-close"
                                  @click.stop="selectedOutcomeFilter = null"
                                  dense
                                  flat
                                  round
                                  size="xs"
                                ></q-btn>
                              </q-card>
                            </div>
                          </div>
                          <div
                            class="full-width"
                            style="min-height: 2px; background: #eeeeee"
                          ></div>
                          <div class="row q-py-md">
                            <div class="filtersTitle">Categories</div>
                          </div>
                          <div class="row q-col-gutter-md">
                            <div class="col-4">
                              <div class="row">
                                <div class="filtersSubTitle">Difficulty</div>
                              </div>
                              <q-select
                                v-model="selectedDifficultyFilter"
                                :options="filterOptions[2].children"
                                :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                                color="white"
                                dropdown-icon="mdi-chevron-down"
                                :label-color="'white'"
                                dense
                                class="specialDropdownStyles"
                                option-label="label"
                                option-value="value"
                                emit-value
                                map-options
                              >
                                <template v-slot:option="scope">
                                  <q-item
                                    class="bg-white option"
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    clickable
                                    v-ripple
                                  >
                                    <q-item-section>
                                      <q-item-label
                                        class="option-label text-black"
                                        v-html="scope.opt['label']"
                                      >
                                      </q-item-label>
                                    </q-item-section>
                                  </q-item>
                                </template>
                              </q-select>
                            </div>
                            <div class="col-4">
                              <div class="row">
                                <div class="filtersSubTitle">Cost</div>
                              </div>
                              <q-select
                                v-model="selectedCostFilter"
                                :options="filterOptions[0].children"
                                :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                                color="white"
                                dropdown-icon="mdi-chevron-down"
                                :label-color="'white'"
                                dense
                                class="specialDropdownStyles"
                                option-label="label"
                                option-value="value"
                                emit-value
                                map-options
                              >
                                <template v-slot:option="scope">
                                  <q-item
                                    class="bg-white option"
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    clickable
                                    v-ripple
                                  >
                                    <q-item-section>
                                      <q-item-label
                                        class="option-label text-black"
                                        v-html="scope.opt['label']"
                                      >
                                      </q-item-label>
                                    </q-item-section>
                                  </q-item>
                                </template>
                              </q-select>
                            </div>
                            <div class="col-4">
                              <div class="row">
                                <div class="filtersSubTitle">Impact</div>
                              </div>
                              <q-select
                                v-model="selectedImpactFilter"
                                :options="filterOptions[1].children"
                                :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                                color="white"
                                dropdown-icon="mdi-chevron-down"
                                :label-color="'white'"
                                dense
                                class="specialDropdownStyles"
                                option-label="label"
                                option-value="value"
                                emit-value
                                map-options
                              >
                                <template v-slot:option="scope">
                                  <q-item
                                    class="bg-white option"
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    clickable
                                    v-ripple
                                  >
                                    <q-item-section>
                                      <q-item-label
                                        class="option-label text-black"
                                        v-html="scope.opt['label']"
                                      >
                                      </q-item-label>
                                    </q-item-section>
                                  </q-item>
                                </template>
                              </q-select>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div class="filtersSubTitle">
                                  Area of Business
                                </div>
                              </div>
                              <q-select
                                v-model="selectedAreaOfBizFilter"
                                :options="areaOfBizOptions"
                                :style="`
                                    background-color: white;
                                    border-radius: 7px;
                                    `"
                                color="white"
                                dropdown-icon="mdi-chevron-down"
                                :label-color="'white'"
                                dense
                                class="specialDropdownStyles"
                              >
                                <template v-slot:option="scope">
                                  <q-item
                                    class="bg-white option"
                                    v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    clickable
                                    v-ripple
                                  >
                                    <q-item-section>
                                      <q-item-label
                                        class="option-label text-black"
                                        v-html="scope.opt"
                                      >
                                      </q-item-label>
                                    </q-item-section>
                                  </q-item>
                                </template>
                              </q-select>
                            </div>
                          </div>
                        </div>
                      </q-menu>
                    </div>
                    <div
                      class="filterButton q-mr-sm"
                      v-if="selectedOutcomeFilter"
                    >
                      <div class="row items-center q-pl-sm">
                        <span class="filtersText">
                          {{ selectedOutcomeFilter.name }}
                        </span>
                        <q-btn
                          icon="mdi-close"
                          flat
                          size="sm"
                          rounded
                          @click="selectedOutcomeFilter = null"
                        >
                        </q-btn>
                      </div>
                    </div>
                    <div
                      class="filterButton q-mr-sm"
                      v-if="selectedCostFilter && selectedCostFilter != 'none'"
                    >
                      <div class="row items-center q-pl-sm">
                        <span class="filtersText">
                          Cost: {{ selectedCostFilter }}
                        </span>
                        <q-btn
                          icon="mdi-close"
                          flat
                          size="sm"
                          rounded
                          @click="selectedCostFilter = null"
                        >
                        </q-btn>
                      </div>
                    </div>
                    <div
                      class="filterButton q-mr-sm"
                      v-if="
                        selectedDifficultyFilter &&
                        selectedDifficultyFilter != 'none'
                      "
                    >
                      <div class="row items-center q-pl-sm">
                        <span class="filtersText">
                          Difficulty: {{ selectedDifficultyFilter }}
                        </span>
                        <q-btn
                          icon="mdi-close"
                          flat
                          size="sm"
                          rounded
                          @click="selectedDifficultyFilter = null"
                        >
                        </q-btn>
                      </div>
                    </div>
                    <div
                      class="filterButton"
                      v-if="
                        selectedImpactFilter && selectedImpactFilter != 'none'
                      "
                    >
                      <div class="row items-center q-pl-sm">
                        <span class="filtersText">
                          Impact: {{ selectedImpactFilter }}
                        </span>
                        <q-btn
                          size="sm"
                          icon="mdi-close"
                          flat
                          rounded
                          @click="selectedImpactFilter = null"
                        >
                        </q-btn>
                      </div>
                    </div>
                    <div
                      class="filterButton q-mr-sm"
                      v-if="
                        selectedAreaOfBizFilter &&
                        selectedAreaOfBizFilter != 'All'
                      "
                    >
                      <div class="row items-center q-pl-sm">
                        <span class="filtersText">
                          Area: {{ selectedAreaOfBizFilter }}
                        </span>
                        <q-btn
                          icon="mdi-close"
                          flat
                          size="sm"
                          rounded
                          @click="selectedAreaOfBizFilter = 'All'"
                        >
                        </q-btn>
                      </div>
                    </div>
                  </div>
                </template>
              </topbar>
            </div>
          </div>
        </div>
        <div class="row q-mt-md">
          <div class="row q-col-gutter-y-sm full-width">
            <div class="col-12">
              <div class="row justify-between">
                <!-- <q-checkbox
                    v-if="!grid"
                    style="margin: auto"
                    v-model="selected"
                    @input="$refs.datatable.selectAll(selected)"
                  ></q-checkbox>
                  <q-btn
                    icon="mdi-dots-vertical"
                    flat
                    color="black"
                    padding="0px"
                  >
                  </q-btn> -->
                <div>
                  <div class="row items-center q-ml-lg">
                    <span class="text-accent searchByKeyword q-mr-md">
                      Search by Keyword
                    </span>
                    <q-input dense filled v-model="keywordSearch"></q-input>
                  </div>
                </div>

                <div>
                  <div class="row items-center">
                    <q-btn
                      flat
                      @click="grid = true"
                      icon="mdi-view-grid"
                      :color="grid ? 'primary' : 'grey'"
                      no-caps
                    >
                      <span class="q-mx-sm text-grey button-text"> Grid </span>
                    </q-btn>
                    <q-btn
                      flat
                      @click="grid = false"
                      icon="mdi-format-list-checkbox"
                      :color="grid ? 'grey' : 'primary'"
                      no-caps
                    >
                      <span class="q-mx-sm text-black button-text"> List </span>
                    </q-btn>
                    <span class="button-text q-mr-sm"> Sort By </span>
                    <q-select
                      class="q-mr-lg"
                      style="display: inline-block; width: 160px"
                      dense
                      v-model="sortByDropdown"
                      :options="sortByDropdownOptions"
                      filled
                    ></q-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <!--GRID VIEW-->
              <div class="q-pa-xs" v-if="grid">
                <q-scroll-area
                  :thumb-style="{
                    background: '#162c479c',
                    opacity: 1,
                    width: '8px',
                    height: '8px',
                    borderRadius: '20px',
                  }"
                  :visible="true"
                  style="height: calc(100vh - 293px) !important"
                >
                  <div
                    class="row justify-center items-center"
                    style="height: calc(100vh - 275px)"
                  >
                    <div
                      class="q-py-xs q-px-sm"
                      v-for="(solution, i) in paginatedData"
                      :key="i"
                    >
                      <grid-card
                        :customContent="true"
                        :customImage="true"
                        style="width: 217px; height: 294px"
                        bottomIcon="mdi-eye-outline"
                        :bottomIconText="`(${
                          solution.views ? solution.views : 0
                        })`"
                        @onClick="initSolutionSummary(solution)"
                        @dblclick="openSolutionsDialog"
                        class="cursor-pointer"
                      >
                        <template v-slot:image>
                          <q-img :src="solution.imageUrl" style="height: 144px">
                            <div
                              class="full-width bg-transparent"
                              style="padding: 10px !important"
                            >
                              <div class="row justify-between">
                                <div>
                                  <checkmark
                                    v-if="solution.solutionsBusiness_id"
                                  />
                                </div>
                                <div class="row">
                                  <div
                                    :class="`${
                                      i < solution.outcomes.length - 1
                                        ? 'q-mr-md'
                                        : ''
                                    }`"
                                    v-for="(outcome, i) in solution.outcomes"
                                    :key="i"
                                  >
                                    <q-img
                                      class="q-mx-auto"
                                      style="width: 23px; height: 23px"
                                      :src="
                                        getOutcomeImage({ name: outcome.name })
                                      "
                                    >
                                      <q-tooltip>
                                        {{ outcome.label }}
                                      </q-tooltip>
                                    </q-img>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </q-img>
                        </template>
                        <template v-slot:content>
                          <div class="row justify-between q-mt-sm">
                            <div class="row justify-center">
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px;opacity:${
                                    !solution.ease ? '0.5' : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !solution.ease || solution.ease == 'Low'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !solution.ease || solution.ease != 'High'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                            </div>
                            <div class="row justify-center">
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px;opacity:${
                                    !solution.cost ? '0.5' : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !solution.cost || solution.cost == 'Low'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !solution.cost || solution.cost != 'High'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                            </div>
                          </div>
                          <div class="row q-mt-sm">
                            <span
                              class="solutionGridTitle"
                              style="height: 36px"
                            >
                              {{ solution.title }}
                            </span>
                          </div>
                          <div class="row" style="height: 55px">
                            <span
                              class="solutionGridDesc"
                              style="overflow: scroll"
                            >
                              {{ solution.description }}
                            </span>
                          </div>
                        </template>
                      </grid-card>
                    </div>
                  </div>
                </q-scroll-area>
                <div class="row items-center">
                  <div class="col-auto">
                    <q-btn
                      v-if="$route.name == 'solutionWelderSolutionsDatabase'"
                      color="accent"
                      class="q-px-sm q-py-xs bg-secondary"
                      style="margin-left: 12px"
                      text-color="white"
                      no-caps
                      @click="
                        $router.push($route.path.split('/solutionsDatabase')[0])
                      "
                      flat
                    >
                      <span class="buttonText"> Back to Welder </span>
                    </q-btn>
                  </div>
                  <div class="col text-right q-px-sm">
                    Page <b class="text-accent">{{ currentPage }}</b> -
                    {{ Math.ceil(filteredSolutionsList.length / itemsPerPage) }}
                    of {{ filteredSolutionsList.length }} Results
                    <q-btn
                      icon="mdi-chevron-left"
                      flat
                      round
                      dense
                      :disable="currentPage == 1"
                      @click="currentPage -= 1"
                    ></q-btn>
                    <q-btn
                      icon="mdi-chevron-right"
                      :disable="
                        currentPage ==
                        Math.ceil(filteredSolutionsList.length / itemsPerPage)
                      "
                      flat
                      dense
                      round
                      @click="currentPage += 1"
                    ></q-btn>
                  </div>
                </div>
              </div>
              <!-- LIST VIEW-->
              <div v-else class="q-pa-sm" style="">
                <sustainability-data-table
                  style="height: calc(100vh - 305px) !important"
                  ref="datatable"
                  @rowDoubleClick="openSolutionsDialog"
                  @rowSelected="initSolutionSummary"
                  :columns="columns"
                  :data="filteredSolutionsList"
                  updateBody
                  bodyHoverColor="#4ac7e933"
                  bodyAltColor="#F6F6F6"
                  :grid="grid"
                  flat
                  :hideBottom="!grid"
                  :square="true"
                  separator="none"
                  :isCustomHeader="true"
                  selection="single"
                  headerBgColor="white"
                  headerTextColor="white"
                  :headerDark="true"
                  id="solutionsTable"
                >
                  <template slot="header" slot-scope="data">
                    <q-tr :props="data.props" style="z-index: 100">
                      <template
                        v-for="col in data.props.cols"
                        v-bind:props="data.props"
                        :name="`header-cell-${col.name}`"
                      >
                        <q-th :key="col.name" :props="data.props">
                          <span class="column-text text-accent">
                            {{ col.label }}
                          </span>
                        </q-th>
                      </template>
                    </q-tr>
                  </template>
                  <!--LIST TILE LAYOUT-->
                  <template slot="body" slot-scope="data">
                    <q-tr
                      v-ripple
                      class="text-black cursor-pointer"
                      @click="$refs.datatable.handleClick(null, data.props.row)"
                      @dblclick="doubleClickFromTR(null, data.props.row)"
                      :props="data.props"
                      :style="`background-color: ${
                        isSelected(data.props.row, $refs.datatable.selected)
                          ? '#4ac7e933 !important;'
                          : ''
                      }`"
                    >
                      <template
                        v-for="column in data.props.cols"
                        :name="`body-cell-${column.name}`"
                        v-bind:props="data.props"
                      >
                        <q-td
                          v-if="column.name == 'title'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="row items-center">
                            <div class="col">
                              <div
                                class="q-mr-sm solutionTitle-div"
                                v-if="data.props.row.title"
                              >
                                <span class="solutionTitle">
                                  {{ data.props.row.title }}
                                  <q-tooltip v-if="data.props.row.title">
                                    {{ data.props.row.title }}
                                  </q-tooltip>
                                </span>
                              </div>
                            </div>
                          </div>
                        </q-td>
                        <!-- <q-td
                            v-else-if="column.name == 'description'"
                            :key="column.name"
                            :props="data.props"
                          >
                            <q-btn
                              flat
                              round
                              icon="mdi-message-text"
                              style="color: #444444cc"
                            >
                              <q-tooltip
                                anchor="top right"
                                self="top start"
                                v-if="data.props.row.description"
                              >
                                {{ data.props.row.description }}
                              </q-tooltip>
                            </q-btn>
                          </q-td> -->
                        <q-td
                          v-else-if="column.name == 'outcomesImpacted'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="q-mr-sm" v-if="data.props.row.outcomes">
                            <div
                              class="row justify-center"
                              style="min-width: 100px"
                            >
                              <div
                                class="q-mr-sm"
                                v-for="(outcome, i) in data.props.row.outcomes"
                                :key="i"
                              >
                                <div class="row">
                                  <q-img
                                    class="q-mx-auto"
                                    style="width: 15px; height: 15px"
                                    :src="
                                      getOutcomeImage({ name: outcome.name })
                                    "
                                  >
                                    <q-tooltip>
                                      {{ outcome.label }}
                                    </q-tooltip>
                                  </q-img>
                                </div>
                              </div>
                            </div>
                          </div>
                        </q-td>
                        <q-td
                          v-else-if="column.name == 'estimatedCost'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="q-mr-sm">
                            <div class="row justify-center">
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px;opacity:${
                                    !data.props.row.cost ? '0.5' : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !data.props.row.cost ||
                                    data.props.row.cost == 'Low'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/money-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !data.props.row.cost ||
                                    data.props.row.cost != 'High'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                            </div>
                          </div>
                          <q-tooltip v-if="data.props.row.cost">
                            {{ data.props.row.cost }}
                          </q-tooltip>
                        </q-td>
                        <q-td
                          v-else-if="column.name == 'easeOfActioning'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="q-mr-sm">
                            <div class="row justify-center">
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px;opacity:${
                                    !data.props.row.ease ? '0.5' : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !data.props.row.ease ||
                                    data.props.row.ease == 'Low'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                              <div class="q-mr-sm">
                                <q-img
                                  src="statics/work-icon.svg"
                                  :style="`width: 15px; height: 15px; opacity:${
                                    !data.props.row.ease ||
                                    data.props.row.ease != 'High'
                                      ? '0.5'
                                      : '1'
                                  }`"
                                ></q-img>
                              </div>
                            </div>
                          </div>
                          <q-tooltip v-if="data.props.row.ease">
                            {{ data.props.row.ease }}
                          </q-tooltip>
                        </q-td>

                        <q-td
                          v-else-if="column.name == 'actions'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="row">
                            <div
                              :class="`workspaceButton q-mr-sm ${
                                data.props.row.solutionsBusiness_id
                                  ? 'bg-primary text-white'
                                  : 'bg-white'
                              }`"
                            >
                              <div
                                class="row justify-center items-center"
                                style="height: 100%"
                              >
                                <span class="text">
                                  {{
                                    data.props.row.solutionsBusiness_id
                                      ? "Saved Solution"
                                      : "Not in Workspace"
                                  }}
                                </span>
                              </div>
                            </div>

                            <div
                              class="learnMoreButton cursor-pointer"
                              @click="learnMore(data.props.row)"
                            >
                              <div
                                class="row justify-center items-center"
                                style="height: 100%"
                              >
                                <span class="text text-white"> Open Card </span>
                              </div>
                            </div>
                          </div>
                        </q-td>

                        <q-td
                          v-else-if="column.name == 'views'"
                          :key="column.name"
                          :props="data.props"
                        >
                          <div class="row justify-center items-center">
                            <div>
                              <q-img
                                src="statics/eye-icon.svg"
                                :style="`width: 13px; height: 9px; color: #6CBD4F`"
                              >
                                <q-tooltip v-if="data.props.row.views">
                                  {{
                                    data.props.row.views
                                      ? data.props.row.views
                                      : 0
                                  }}
                                </q-tooltip>
                              </q-img>
                            </div>

                            <span style="color: #6cbd4f" class="view-text">
                              ({{
                                data.props.row.views ? data.props.row.views : 0
                              }})
                            </span>
                          </div>
                        </q-td>

                        <q-td v-else :key="column.name" :props="data.props">
                          {{ column.value }}
                        </q-td>
                      </template>
                    </q-tr>
                  </template>
                </sustainability-data-table>
                <q-btn
                  v-if="$route.name == 'solutionWelderSolutionsDatabase'"
                  color="accent"
                  class="q-px-sm q-py-xs bg-secondary q-ml-sm q-mt-sm"
                  text-color="white"
                  no-caps
                  @click="
                    $router.push($route.path.split('/solutionsDatabase')[0])
                  "
                  flat
                >
                  <span class="buttonText"> Back to Welder </span>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 25%">
        <side-bar
          class="q-pt-md sidebar_wrapper solutionSummary"
          style="height: calc(100vh - 60px)"
        >
          <div style="height: calc(100vh - 150px)" class="q-px-lg">
            <div class="row">
              <span
                class="suggestedSolutions-title text-accent2"
                style="margin-bottom: 40px"
              >
                Solution Summary
              </span>
            </div>
            <div v-if="selectedSolution">
              <div class="row q-mt-md">
                <div>
                  <div>Choosing to</div>

                  <div class="solutionTitle">
                    {{ selectedSolution.title }}
                  </div>

                  <div class="q-mt-md">We estimate could be</div>
                </div>
              </div>
              <div class="row">
                <div>
                  <span class="solutionStatus"
                    >{{ getCostLabel(selectedSolution.cost) }} Cost</span
                  >
                  <br />
                  <span class="solutionStatus"
                    >{{ getImpactLabel(selectedSolution) }} Impact</span
                  >
                  <br />
                  and
                  <br />
                  <span class="solutionStatus"
                    >{{
                      getDifficultyLabel(selectedSolution.ease)
                    }}
                    Difficulty</span
                  >
                </div>
              </div>
              <div class="row q-mt-md">
                <div>
                  and will impact your

                  <p
                    class="outcomeName"
                    v-if="selectedSolution.outcomes.length > 0"
                  >
                    {{ selectedSolution.outcomes[0].outcomeLabel }} <br />
                    <span v-if="selectedSolution.outcomes.length > 1">
                      {{ `& ${selectedSolution.outcomes[1].outcomeLabel}` }}
                    </span>
                    <span v-if="selectedSolution.outcomes.length > 2">
                      {{ `& ${selectedSolution.outcomes[2].outcomeLabel}` }}
                    </span>
                  </p>
                  <span class="q-mt-sm"> Outcomes. </span>
                </div>
              </div>
            </div>
            <div v-else>
              The <b class="text-accent2">Solution Database</b> is a powerful
              library of ideas that make it easy for you to find ways of
              achieving your sustainability goals. <br /><br />
              By clicking and opening a solution card, it will reveal a pocket
              full of value.
              <br /><br />
              <i style="font-size: 0.7rem"
                >Search for solutions and save them to your workspace, so you
                can weld them to your goals.</i
              >
            </div>
          </div>
          <div class="row justify-center">
            <div>
              <q-btn
                v-if="
                  selectedSolution && !selectedSolution.solutionsBusiness_id
                "
                color="accent"
                class="text-white"
                :disable="!selectedSolution"
                no-caps
                @click="adoptSolution"
                unelevated
              >
                <span class="buttonText"> Save this Solution </span>
              </q-btn>
              <q-btn
                v-else-if="
                  selectedSolution && selectedSolution.solutionsBusiness_id
                "
                color="accent"
                class="text-white"
                :disable="!selectedSolution"
                no-caps
                @click="removeSolution"
                unelevated
              >
                <span class="buttonText"> Remove Solution </span>
              </q-btn>
            </div>
          </div>
        </side-bar>
      </div>
    </div>
    <q-dialog v-model="solutionDialog" persistent full-height>
      <solutions-dialog @closeDialog="closeSolutionDialog"></solutions-dialog>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import SideBar from "@/components/sidebar/sidebar.vue";
import Topbar from "@/components/topbar/topbar.vue";
import SolutionsDialog from "@/components/solutionsDatabase/solutionsDialog.vue";
import GridCard from "@/components/datatable/gridCard.vue";
import checkmark from "@/components/icons/checkmark.vue";
export default {
  components: {
    SustainabilityDataTable,
    Topbar,
    SideBar,
    SolutionsDialog,
    GridCard,
    checkmark,
  },
  mounted() {
    // itemsPerPage
    this.itemsPerPage =
      Math.floor((window.innerWidth * 0.75 - 50) / 233) *
      Math.floor((window.innerHeight - 293) / 310); // Calculating the amount of solutions per page

    this.$store.dispatch("solutions/business/loadAll");
    this.$store.dispatch("outcomes/loadAll").then(() => {
      let index = this.filterOptions.findIndex((e) => e.name == "outcome");
      if (index > -1) {
        this.outcomesList.forEach((outcome) => {
          this.filterOptions[index].children.push({
            name: outcome.name.toLowerCase(),
            label: outcome.label,
            selected: false,
          });
        });
      }
    });
    this.handleRoute();
  },
  watch: {
    solutionsList: {
      handler() {
        this.updateSolutionSummary();
      },
      deep: true,
    },
    filteredSolutionsList() {
      this.currentPage = 1;
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      solutionsList: "solutions/business/list",
      outcomesList: "outcomes/list",
    }),
    totalResults() {
      // total data showing
      return this.solutionsList.length;
    },
    isMaxPage() {
      if (
        this.currentPage ==
        Math.ceil(this.solutionsList.length / this.itemsPerPage)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isMinPage() {
      if (this.currentPage == 1) {
        return true;
      } else {
        return false;
      }
    },
    filteredSolutionsList() {
      let filteredList = [...this.solutionsList];
      let selectedFilters = [];
      this.filters.forEach((filter) => {
        let index = selectedFilters.findIndex(
          (e) => filter.parentName == e.parentName
        );
        if (index <= -1) {
          selectedFilters.push({
            parentName: filter.parentName,
            selectedFilters: [filter.label],
          });
        } else {
          selectedFilters[index].selectedFilters.push(filter.label);
        }
      });

      //filter by selectedFilter
      if (this.selectedCostFilter && this.selectedCostFilter != "none") {
        filteredList = filteredList.filter((solution) =>
          this.selectedCostFilter.includes(solution.cost)
        );
      }
      if (
        this.selectedDifficultyFilter &&
        this.selectedDifficultyFilter != "none"
      ) {
        filteredList = filteredList.filter((solution) =>
          this.selectedDifficultyFilter.includes(solution.ease)
        );
      }

      if (this.selectedImpactFilter && this.selectedImpactFilter != "none") {
        filteredList = filteredList.filter((solution) => {
          for (let i = 0; i < solution.outcomes.length; i++) {
            if (
              this.selectedImpactFilter.includes(solution.outcomes[i].impact)
            ) {
              return solution;
            }
          }
        });
      }

      if (
        this.selectedAreaOfBizFilter &&
        this.selectedAreaOfBizFilter != "All"
      ) {
        filteredList = filteredList.filter((solution) => {
          if (
            !solution.areaOfBusiness ||
            !JSON.parse(solution.areaOfBusiness)
          ) {
            return false;
          }
          return JSON.parse(solution.areaOfBusiness).includes(
            this.selectedAreaOfBizFilter
          );
        });
      }

      if (this.selectedOutcomeFilter) {
        filteredList = filteredList.filter((solution) => {
          for (let i = 0; i < solution.outcomes.length; i++) {
            if (
              this.selectedOutcomeFilter.name.includes(
                solution.outcomes[i].name
              )
            ) {
              return solution;
            }
          }
        });
      }

      //show saved solutions
      if (this.showSavedSolutions) {
        filteredList = filteredList.filter((e) => e.solutionsBusiness_id);
      }

      if (this.sortByDropdown == "Newest") {
        filteredList = filteredList.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
      } else if (this.sortByDropdown == "Oldest") {
        filteredList = filteredList.sort((a, b) => {
          return new Date(a.created_at) - new Date(b.created_at);
        });
      } else if (this.sortByDropdown == "Quick Wins") {
        filteredList = filteredList.sort((a, b) => {
          if (a.quickWin == 1) return -1;
          if (b.quickWin == 1) return 1;
          return 0;
        });
      } else if (this.sortByDropdown == "Most Viewed") {
        filteredList = filteredList.sort((a, b) => {
          return b.views - a.views;
        });
      }

      filteredList = filteredList.filter((e) => {
        if (this.keywordSearch) {
          if (
            e.title.toLowerCase().includes(this.keywordSearch.toLowerCase())
          ) {
            return e;
          } else if (
            e.description &&
            e.description
              .toLowerCase()
              .includes(this.keywordSearch.toLowerCase())
          ) {
            return e;
          } else if (
            e.id.toString().includes(this.keywordSearch.toLowerCase())
          ) {
            return e;
          } else if (
            e.help &&
            e.help.toString().includes(this.keywordSearch.toLowerCase())
          ) {
            return e;
          }
        } else {
          return e;
        }
      });

      return filteredList;
    },
    paginatedData() {
      return this.paginate(
        this.filteredSolutionsList,
        this.itemsPerPage,
        this.currentPage
      );
    },
    columns() {
      return [
        {
          name: "title",
          label: "Solutions",
          align: "left",
          style: "min-width: 225px;max-width: 225px;width: 220px",
        },
        // {
        //   name: "description",
        //   label: "Description",
        //   align: "center",
        //   field: "description",
        //   style:
        //     "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        // },
        {
          name: "outcomesImpacted",
          label: "Outcome Impacted",
          align: "center",
        },
        {
          name: "estimatedCost",
          label: "Cost",
          field: "cost",
          align: "center",
        },
        {
          name: "easeOfActioning",
          label: "Difficulty",
          field: "ease",
          align: "center",
        },
        {
          name: "actions",
          label: "",
          field: "solutionsBusiness_id",
        },
        {
          name: "views",
          label: "Views",
          field: "views",
          align: "center",
        },
      ];
    },
  },
  data: () => ({
    //selected solutions
    selectedSolution: null,
    keywordSearch: "",

    //items per page
    itemsPerPage: 8,
    currentPage: 1,

    //custom headers
    sortByDropdown: "Quick Wins",
    sortByDropdownOptions: ["Quick Wins", "Newest", "Oldest", "Most Viewed"],
    grid: false,
    selected: [],
    filters: [],
    //filters
    selectedOutcomeFilter: null,
    selectedCostFilter: "none",
    selectedImpactFilter: "none",
    selectedDifficultyFilter: "none",

    filterOptions: [
      {
        name: "estimated cost",
        label: "Estimated Cost",
        selected: false,
        children: [
          {
            name: "none",
            label: "Any",
            selected: false,
            value: "none",
          },
          {
            name: "low",
            label: "Low",
            value: "Low",
            selected: false,
          },
          {
            name: "moderate",
            label: "Moderate",
            selected: false,
            value: "Moderate",
          },
          {
            name: "high",
            label: "High",
            selected: false,
            value: "High",
          },
        ],
      },
      {
        name: "estimated impact",
        label: "Estimated Impact",
        selected: false,
        children: [
          {
            name: "none",
            label: "Any",
            selected: false,
            value: "none",
          },
          {
            name: "low",
            label: "Low",
            selected: false,
            value: "Low",
          },
          {
            name: "moderate",
            label: "Moderate",
            selected: false,
            value: "Moderate",
          },
          {
            name: "high",
            label: "High",
            selected: false,
            value: "High",
          },
        ],
      },
      {
        name: "ease of actioning",
        label: "Ease of Actioning",
        selected: false,
        children: [
          {
            name: "none",
            label: "Any",
            selected: false,
            value: "none",
          },
          {
            name: "low",
            label: "Low",
            selected: false,
            value: "Low",
          },
          {
            name: "moderate",
            label: "Moderate",
            selected: false,
            value: "Moderate",
          },
          {
            name: "high",
            label: "High",
            selected: false,
            value: "High",
          },
        ],
      },
      { name: "outcome", label: "Outcome", children: [] },
    ],
    //solution dialog
    solutionDialog: false,
    showSavedSolutions: false,

    selectedAreaOfBizFilter: "All",
    areaOfBizOptions: [
      "All",
      "Vehicles & Transport",
      "Shipping & Exporting",
      "Office & Building",
      "Site & Project",
      "Materials, Products & Assets",
      "Leadership & Strategy",
      "Environment-Related",
      "Other",
    ],
  }),

  methods: {
    selectFilter(type, filter) {
      switch (type) {
        case "outcome":
          if (filter === "none") {
            this.selectedOutcomeFilter = null;
          } else {
            this.selectedOutcomeFilter = filter;
          }

          break;
        case "difficulty":
          if (filter === "none") {
            this.selectedDifficultyFilter = null;
          } else {
            this.selectedDifficultyFilter = filter;
          }
          break;
        case "cost":
          if (filter === "none") {
            this.selectedCostFilter = null;
          } else {
            this.selectedCostFilter = filter;
          }
          break;

        case "impact":
          if (filter === "none") {
            this.selectedImpactFilter = null;
          } else {
            this.selectedImpactFilter = filter;
          }
          break;
      }
    },
    initSolutionSummary(solution) {
      this.selectedSolution = solution;
    },
    openSolutionsDialog() {
      this.$router.push(`${this.$route.path}/` + this.selectedSolution.id);
    },
    closeSolutionDialog() {
      this.$router.push(
        `${this.$route.path.split("/solutionsDatabase")[0]}/solutionsDatabase`
      );
      this.solutionDialog = false;
    },
    handleRoute() {
      if (this.$route.params.hasOwnProperty("id")) {
        this.solutionDialog = true;
      }
    },
    learnMore(solution) {
      this.initSolutionSummary(solution);
      this.openSolutionsDialog();
    },
    updateSolutionSummary() {
      if (this.selectedSolution) {
        let index = this.solutionsList.findIndex(
          (e) => e.id == this.selectedSolution.id
        );
        if (index > -1) {
          this.selectedSolution = this.solutionsList[index];
        }
      }
    },
    async removeSolution() {
      let payload = {
        id: this.selectedSolution.solutionsBusiness_id,
        solutions_id: this.selectedSolution.id,
        deleted_at: true,
      };
      let result = await this.$store.dispatch(
        "solutions/business/removeSolution",
        payload
      );
      this.$forceUpdate();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async adoptSolution() {
      let payload = {
        solutions_id: this.selectedSolution.id,
      };
      let result = await this.$store.dispatch(
        "solutions/business/new",
        payload
      );
      this.$forceUpdate();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    getCostLabel(cost) {
      if (cost == "Low") {
        return "Low";
      } else if (cost == "Moderate") {
        return "Moderate";
      } else {
        return "High";
      }
    },
    getDifficultyLabel(ease) {
      if (ease == "Low") {
        return "Low";
      } else if (ease == "Moderate") {
        return "Moderate";
      } else {
        return "High";
      }
    },
    getImpactLabel(solution) {
      let impact = "Low";

      for (let i = 0; i < solution.outcomes.length; i++) {
        if (solution.outcomes[i].impact == "High") {
          return "High";
        }

        if (solution.outcomes[i].impact == "Moderate") {
          impact = "Moderate";
        }
      }

      return impact;
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
    isSelected(row, selectedArray) {
      let index = selectedArray.findIndex((e) => e.id == row.id);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    },
    nextPage(isNext) {
      if (isNext) {
        if (
          this.currentPage <
          Math.ceil(this.solutionsList.length / this.itemsPerPage)
        ) {
          this.currentPage = this.currentPage + 1;
        }
      } else {
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
        }
      }
    },
    getOutcomeImage: (outcome) => getOutcomeImage(outcome),
    doubleClickFromTR(e, row) {
      this.$refs.datatable.handleDoubleClick(e, row);
    },
    checkAllSelected(selectedArray) {
      if (selectedArray.length != this.filteredSolutionsList.length) {
        this.selected = false;
      } else if (selectedArray.length == this.filteredSolutionsList.length) {
        this.selected = true;
      }
    },
    filterSolutionsList(val) {
      this.filters = [...val];
    },
    updateSolution(object, key, value) {
      let solutionsList = [...this.solutionsList];
      let index = solutionsList.findIndex((e) => e.id == object.id);
      if (index > -1) {
        solutionsList[index][key] = value;
      }
      this.$store.commit("solutions/setList", solutionsList);
      this.$forceUpdate();
    },
    removeKeyInItemsList(listOfObjects, key) {
      return listOfObjects.map((e) => {
        let object = { ...e };
        delete object[key];
        return object;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filterButton {
  background-color: #f6f6f6;
  height: 27px;
  border-radius: 5px;
}

.showSavedSolutionsText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 11.39px;
}

.filtersText {
  font-weight: 600;
  font-size: 14px;
}
.solutionGridTitle {
  font-family: "Montserrat";
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
}

.solutionGridDesc {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  line-clamp: 3;
  -webkit-box-orient: vertical;
  font-style: normal;
}
.solutionSummary {
  .solutionTitle {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    color: #8ca9a4;
  }

  .solutionStatus {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    color: #4ac7e9;
  }

  .outcomeName {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
  }

  .buttonText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 11.39px;
  }
}
.searchByKeyword {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 11.6054px;
}
.workspaceButton {
  width: 96px;
  height: 26px;
  border-radius: 3px;
  .text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
  }
}

.learnMoreButton {
  width: 77px;
  height: 26px;
  border-radius: 3px;
  background-color: #162c47;
  .text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
  }
}
.header-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.suggestedSolutions-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
}

.sidebar_wrapper {
  background-color: #f6f6f6;
  font-family: "Montserrat";
  font-style: normal;
}

.view-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: -0.02em;
}

.button-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14.6054px;
  line-height: 14px;
}

.column-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}

.solutionTitle {
  color: #162c47;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.solutionTitle-div {
  width: 220px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.filtersTitle {
  font-size: 1rem;
  font-weight: 700;
  color: $accent2;
}

.outcomeCardSelector {
  // background: orange;
  border-radius: 7px;
  font-weight: 700;
  color: $accent2;
  font-size: 0.8rem;
  transition: all 0.15s ease-in-out;

  &.active {
    background: $primary !important;
    color: white;
  }

  &:hover {
    background: #eeeeee;
    cursor: pointer;
  }
}

.filtersSubTitle {
  font-size: 0.8rem;
  font-weight: 700;
  color: $accent2;
}

.option-label {
  font-weight: 400;
  font-size: 13px;
}
</style>
